import type { ConnectedIdentity, ProviderId, ProviderView } from '../../api/apiSchemas';
import { getPresentation } from '../../auth/providerPresentation';
import { formatDate } from '../../lib/formatters';
import { Button } from '../ui';
import './account.css';

export type ConnectionCardProps =
  | {
      kind: 'linked';
      identity: ConnectedIdentity;
      busy: boolean;
      onUnlink: (provider: ProviderId) => void;
    }
  | {
      kind: 'available';
      provider: ProviderView;
      busy: boolean;
      onLink: (provider: ProviderId) => void;
    };

function unlinkDisabledHint(reason: ConnectedIdentity['unlinkDisabledReason']): string {
  if (reason === 'LAST_AUTH_METHOD') {
    return 'Đây là phương thức đăng nhập cuối cùng. Hãy liên kết thêm một phương thức khác trước.';
  }
  if (reason === 'POLICY') return 'Không thể gỡ liên kết theo chính sách hiện tại.';
  return '';
}

export function ConnectionCard(props: ConnectionCardProps) {
  if (props.kind === 'linked') {
    const { identity, busy, onUnlink } = props;
    const presentation = getPresentation(identity.provider);
    const hint = identity.canUnlink ? '' : unlinkDisabledHint(identity.unlinkDisabledReason);
    return (
      <div className="connection-card">
        <div className="stack" style={{ gap: 4 }}>
          <span className="connection-card__title">
            <img src={presentation.iconAsset} alt="" aria-hidden="true" />
            {presentation.displayName}
          </span>
          <span className="muted" style={{ fontSize: '0.9rem' }}>
            Đã liên kết ngày {formatDate(identity.linkedAt)}
          </span>
          {identity.emailMasked ? (
            <span className="muted" style={{ fontSize: '0.9rem' }}>
              Email: {identity.emailMasked}
            </span>
          ) : null}
          {hint ? (
            <span className="muted" style={{ fontSize: '0.85rem' }}>
              {hint}
            </span>
          ) : null}
        </div>
        <Button
          variant="secondary"
          disabled={!identity.canUnlink || busy}
          onClick={() => onUnlink(identity.provider)}
        >
          Gỡ liên kết
        </Button>
      </div>
    );
  }

  const { provider, busy, onLink } = props;
  const presentation = getPresentation(provider.id);
  return (
    <div className="connection-card">
      <span className="connection-card__title">
        <img src={presentation.iconAsset} alt="" aria-hidden="true" />
        {presentation.displayName}
      </span>
      <Button variant="primary" loading={busy} disabled={busy} onClick={() => onLink(provider.id)}>
        {presentation.linkLabel}
      </Button>
    </div>
  );
}
